import PropTypes from 'prop-types';
import styled, { css } from 'foundations-theming/utils';
// @ts-expect-error untyped modules
import GlobalContentNoAccessLabel from './GlobalContentNoAccessLabel';
import ModuleNotDraggableLabel from './ModuleNotDraggableLabel';
import { LAYOUT_SECTION_HOVER_OVERLAY_COLORS as COLORS } from '../lib/layoutSection/constants';
// @ts-expect-error untyped modules
import EditorConfigSingleton from 'ContentEditorUI/EditorConfigSingleton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const withAlpha = (hex, opacity) => {
  const hexOpacity = Math.round(opacity * 255).toString(16).padStart(2, '0');
  return `${hex}${hexOpacity}`;
};
const repeatingLinearGratient = (angle, ...colorStops) => `
  repeating-linear-gradient(${angle}deg, ${colorStops.join(', ')});
`;
const unEditableDiagonalBars = css(["background:", ";"], repeatingLinearGratient(45, withAlpha(COLORS.UNEDITABLE_DIAGONAL_BARS_ONE, 0.2), `${withAlpha(COLORS.UNEDITABLE_DIAGONAL_BARS_ONE, 0.2)} 30px`, `${withAlpha(COLORS.UNEDITABLE_DIAGONAL_BARS_TWO, 0.6)} 30px`, `${withAlpha(COLORS.UNEDITABLE_DIAGONAL_BARS_TWO, 0.6)} 60px`));
const removeModuleDiagonalBars = css(["background:", ";"], repeatingLinearGratient(135, withAlpha(COLORS.REMOVE_MODULE_DIAGONAL_BARS_ONE, 0.2), `${withAlpha(COLORS.REMOVE_MODULE_DIAGONAL_BARS_ONE, 0.2)} 30px`, `${withAlpha(COLORS.REMOVE_MODULE_DIAGONAL_BARS_TWO, 0.6)} 30px`, `${withAlpha(COLORS.REMOVE_MODULE_DIAGONAL_BARS_TWO, 0.6)} 60px`));
const cleanLinesRemoveModuleDiagonalBars = css(["background:", ";"], repeatingLinearGratient(135, withAlpha(COLORS.REMOVE_MODULE_DIAGONAL_BARS_ONE, 0.15), `${withAlpha(COLORS.REMOVE_MODULE_DIAGONAL_BARS_ONE, 0.15)} 30px`, `${withAlpha(COLORS.REMOVE_MODULE_DIAGONAL_BARS_TWO, 0.5)} 30px`, `${withAlpha(COLORS.REMOVE_MODULE_DIAGONAL_BARS_TWO, 0.5)} 60px`));
const updatedEditorStyles = css(["outline:2px solid ", ";outline-offset:-2px;background:none;"], COLORS.UPDATED_OUTLINE);
const baseGlobalEmbedOrGroupStyles = css(["cursor:pointer;pointer-events:auto;z-index:5000;"]);
const globalGroupUpdatedEditorStyles = css(["background-color:", ";outline:2px solid ", ";"], withAlpha(COLORS.GLOBAL_GROUP_BACKGROUND, 0.4), COLORS.GLOBAL_GROUP_OUTLINE);
const embedUpdatedEditorStyles = css(["background-color:", ";outline:2px solid ", ";"], withAlpha(COLORS.EMBED_BACKGROUND, 0.2), COLORS.EMBED_OUTLINE);
const moduleBlockedStyles = css(["", " cursor:not-allowed;"], unEditableDiagonalBars);
const moduleWithoutAccessStyles = css(["", " cursor:pointer;outline-color:", ";pointer-events:auto;"], removeModuleDiagonalBars, COLORS.MODULE_WITHOUT_ACCESS_OUTLINE);
const richTextWihtoutAccessStyles = css(["background:", " !important;cursor:pointer;outline-color:", " !important;pointer-events:auto;"], withAlpha(COLORS.RICH_TEXT_WITHOUT_ACCESS_BACKGROUND, 0.2), COLORS.RICH_TEXT_WITHOUT_ACCESS_OUTLINE);
const StyledLayoutSectionHoverOverlay = styled.div.withConfig({
  displayName: "LayoutSectionHoverOverlay__StyledLayoutSectionHoverOverlay",
  componentId: "iqs8dt-0"
})([".hs-private.hs-private.hs-private &&{position:absolute;background:", ";box-sizing:border-box;outline:3px solid ", ";outline-offset:-3px;", " ", " ", " ", " ", " ", " ", " ", " ", "}"], withAlpha(COLORS.DEFAULT_BACKGROUND, 0.3), COLORS.DEFAULT_OUTLINE, ({
  $isNonLSModuleHoverOverlayGlobalGroup,
  $isNonLSModuleHoverOverlayEmbed
}) => ($isNonLSModuleHoverOverlayGlobalGroup || $isNonLSModuleHoverOverlayEmbed) && baseGlobalEmbedOrGroupStyles, ({
  $isUneditable
}) => $isUneditable && unEditableDiagonalBars, ({
  $isNonLSModuleHoverOverlayBlocked
}) => $isNonLSModuleHoverOverlayBlocked && moduleBlockedStyles, ({
  $hasUpdatedEditorStyles
}) => $hasUpdatedEditorStyles && updatedEditorStyles, ({
  $isNonLSModuleHoverOverlayGlobalGroup,
  $hasUpdatedEditorStyles
}) => $isNonLSModuleHoverOverlayGlobalGroup && $hasUpdatedEditorStyles && globalGroupUpdatedEditorStyles, ({
  $isNonLSModuleHoverOverlayEmbed,
  $hasUpdatedEditorStyles
}) => $isNonLSModuleHoverOverlayEmbed && $hasUpdatedEditorStyles && embedUpdatedEditorStyles, ({
  $isNonLSModuleHoverOverlayWithoutAccess
}) => $isNonLSModuleHoverOverlayWithoutAccess && moduleWithoutAccessStyles, ({
  $hasCleanLinesWithoutAccessBars
}) => $hasCleanLinesWithoutAccessBars && cleanLinesRemoveModuleDiagonalBars, ({
  $isNonLSModuleHoverOverlayRichTextWithModulesWithoutAccess
}) => $isNonLSModuleHoverOverlayRichTextWithModulesWithoutAccess && richTextWihtoutAccessStyles);
const LayoutSectionHoverOverlay = ({
  id,
  cursor,
  hasContentEmbedAccess,
  hasGlobalContentEditorAccess,
  height,
  isGlobal,
  isUneditable,
  left,
  onClick,
  onMouseDown,
  onMouseUp,
  opacity,
  pointerEvents,
  isFixedPosition,
  top,
  width,
  isAdvancedModuleWithoutAccess,
  isPaymentsModuleWithoutAccess,
  hasPersonalizationTokenWithoutAccess,
  defaultType,
  isEmbed,
  isStaticSectionModule,
  domNodeRef
}) => {
  var _EditorConfigSingleto;
  const styles = {
    top,
    left,
    width,
    height
  };
  if (opacity != null) {
    styles.opacity = opacity;
  }
  if (cursor != null) {
    styles.cursor = cursor;
  }
  if (isFixedPosition) {
    styles.position = 'fixed';
  }
  if (pointerEvents != null) {
    styles.pointerEvents = pointerEvents;
  }
  const isRichTextModule = defaultType === 'rich_text';
  const isNonLSModuleHoverOverlayBlocked = isGlobal && !hasGlobalContentEditorAccess || isEmbed && !hasContentEmbedAccess;
  const isNonLSModuleHoverOverlayWithoutAccess = isAdvancedModuleWithoutAccess && !isRichTextModule || isPaymentsModuleWithoutAccess;
  const isNonLSModuleHoverOverlayRichTextWithModulesWithoutAccess = isAdvancedModuleWithoutAccess && isRichTextModule || hasPersonalizationTokenWithoutAccess;
  const isNonLSModuleHoverOverlayGlobalGroup = isGlobal && hasGlobalContentEditorAccess;
  const isNonLSModuleHoverOverlayEmbed = isEmbed && hasContentEmbedAccess;
  const hasUpdatedEditorStyles = !isAdvancedModuleWithoutAccess && !isPaymentsModuleWithoutAccess && !hasPersonalizationTokenWithoutAccess;
  const hasCleanLinesWithoutAccessBars = isAdvancedModuleWithoutAccess || isPaymentsModuleWithoutAccess;
  const allowStaticModuleDragToMoveParentSection = ((_EditorConfigSingleto = EditorConfigSingleton.get('inpage')) === null || _EditorConfigSingleto === void 0 ? void 0 : _EditorConfigSingleto.allowStaticModuleDragToMoveParentSection) || false;
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsxs(StyledLayoutSectionHoverOverlay, {
      "data-test-id": "layout-section-hover-overlay",
      onClick: onClick,
      onMouseDown: onMouseDown,
      onMouseUp: onMouseUp,
      $isUneditable: Boolean(isUneditable),
      $isNonLSModuleHoverOverlayBlocked: isNonLSModuleHoverOverlayBlocked,
      $isNonLSModuleHoverOverlayWithoutAccess: isNonLSModuleHoverOverlayWithoutAccess,
      $isNonLSModuleHoverOverlayRichTextWithModulesWithoutAccess: isNonLSModuleHoverOverlayRichTextWithModulesWithoutAccess,
      $isNonLSModuleHoverOverlayGlobalGroup: isNonLSModuleHoverOverlayGlobalGroup,
      $isNonLSModuleHoverOverlayEmbed: isNonLSModuleHoverOverlayEmbed,
      $hasUpdatedEditorStyles: hasUpdatedEditorStyles,
      $hasCleanLinesWithoutAccessBars: hasCleanLinesWithoutAccessBars,
      style: styles,
      ref: domNodeRef,
      children: [isGlobal && !hasGlobalContentEditorAccess && /*#__PURE__*/_jsx(GlobalContentNoAccessLabel, {
        height: height,
        width: width
      }), isStaticSectionModule && !allowStaticModuleDragToMoveParentSection &&
      /*#__PURE__*/
      // The key is for an edge case where two undraggable modules are
      // placed next to each other. When dragging from one of these modules
      // to another, we'll want to remount the overlay so that the
      // useWasDragAttempted state and listeners are reset.
      _jsx(ModuleNotDraggableLabel, {
        height: height,
        width: width
      }, id)]
    })
  );
};
LayoutSectionHoverOverlay.propTypes = {
  id: PropTypes.string.isRequired,
  cursor: PropTypes.string,
  hasContentEmbedAccess: PropTypes.bool.isRequired,
  hasGlobalContentEditorAccess: PropTypes.bool.isRequired,
  height: PropTypes.number.isRequired,
  isGlobal: PropTypes.bool.isRequired,
  isUneditable: PropTypes.bool,
  left: PropTypes.number.isRequired,
  top: PropTypes.number.isRequired,
  isFixedPosition: PropTypes.bool,
  width: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  onMouseUp: PropTypes.func,
  onMouseDown: PropTypes.func,
  opacity: PropTypes.number,
  pointerEvents: PropTypes.string,
  isAdvancedModuleWithoutAccess: PropTypes.bool.isRequired,
  isPaymentsModuleWithoutAccess: PropTypes.bool,
  hasPersonalizationTokenWithoutAccess: PropTypes.bool,
  defaultType: PropTypes.string,
  isEmbed: PropTypes.bool,
  isStaticSectionModule: PropTypes.bool,
  domNodeRef: PropTypes.any
};
export default LayoutSectionHoverOverlay;